export default "__VITE_ASSET__9xhENizc__"